import { downloadFileBlob } from "utils";

import { makeAutoObservable } from "mobx";
import { withRequestTracking, fetchStatus } from "utils/storesUtils";
import { ENDPOINTS, getOfferFieldCodes, OfferFieldType, uploadOfferDoc } from "services";

export class OfferDoc {
  fieldCodes: OfferFieldType[] = [];

  downloadDocStatuses = { loading: false, fetchStatus: fetchStatus.idle, fetchError: undefined };
  codesStatutes = { loading: false, fetchStatus: fetchStatus.idle, fetchError: undefined };
  uploadFileStatuses = { loading: false, fetchStatus: fetchStatus.idle, fetchError: undefined };

  constructor() {
    makeAutoObservable(this);
  }

  async getOfferCodes() {
    return withRequestTracking(this.codesStatutes, async () => {
      const res = await getOfferFieldCodes();
      this.fieldCodes = res;
    });
  }

  async downloadOfferDocFile() {
    return withRequestTracking(this.downloadDocStatuses, async () => {
      await downloadFileBlob(ENDPOINTS.companyOfferFile(), true);
    });
  }

  async downloadOfferTemplateFile() {
    return withRequestTracking(this.downloadDocStatuses, async () => {
      await downloadFileBlob(ENDPOINTS.downloadOfferTemplate(), true);
    });
  }

  async uploadOfferDocFile(file: File) {
    const formData = new FormData();
    formData.append("file", file);

    return withRequestTracking(this.uploadFileStatuses, async () => {
      await uploadOfferDoc({ formData });
    });
  }
}
